"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastProgramAdministrationApi = exports.BroadcastProgramAdministrationApiFactory = exports.BroadcastProgramAdministrationApiFp = exports.BroadcastProgramAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * BroadcastProgramAdministrationApi - axios parameter creator
 * @export
 */
const BroadcastProgramAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: CreateBroadcastProgram - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayın takvimine yeni bir program oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.TrainingCover olmalıdır. PersonalTrainer\'ın varlığı PersonalTrainerMetadata tablosundan kontrol edilmelidir.
         * @param {CreateBroadcastProgramCommand} [createBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBroadcastProgram: (createBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/create_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Yayın programını siler
         * @param {DeleteBroadcastProgramCommand} [deleteBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBroadcastProgram: (deleteBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/delete_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListBroadcastProgramsForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Yayın takvimini yönetim amacıyla listeler.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBroadcastProgramsForAdministration: (page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/list_broadcast_programs_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateCoverPhotoOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının kapak fotoğrafını değiştirmeye yarar.
         * @param {UpdateCoverPhotoOfBroadcastProgramCommand} [updateCoverPhotoOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfBroadcastProgram: (updateCoverPhotoOfBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/update_cover_photo_of_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoverPhotoOfBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateEndMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının sonlanma anını değiştirmeye yarar. Dikkat: Yayının başlama anından sonra olmalıdır.
         * @param {UpdateEndMomentOfBroadcastProgramCommand} [updateEndMomentOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEndMomentOfBroadcastProgram: (updateEndMomentOfBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/update_end_moment_of_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEndMomentOfBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePersonalTrainerOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programını sunacak kişisel antrenörü değiştirmeye yarar.
         * @param {UpdatePersonalTrainerOfBroadcastProgramCommand} [updatePersonalTrainerOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalTrainerOfBroadcastProgram: (updatePersonalTrainerOfBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/update_personal_trainer_of_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePersonalTrainerOfBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateStartMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının başlangıç anını değiştirmeye yarar. Dikkat: Yayının sonlanma tarihinden önce olmalıdır.
         * @param {UpdateStartMomentOfBroadcastProgramCommand} [updateStartMomentOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStartMomentOfBroadcastProgram: (updateStartMomentOfBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/update_start_moment_of_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateStartMomentOfBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateTitleOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının başlığını değiştirmeye yarar.
         * @param {UpdateTitleOfBroadcastProgramCommand} [updateTitleOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfBroadcastProgram: (updateTitleOfBroadcastProgramCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program_administration/update_title_of_broadcast_program`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTitleOfBroadcastProgramCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BroadcastProgramAdministrationApiAxiosParamCreator = BroadcastProgramAdministrationApiAxiosParamCreator;
/**
 * BroadcastProgramAdministrationApi - functional programming interface
 * @export
 */
const BroadcastProgramAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BroadcastProgramAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: CreateBroadcastProgram - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayın takvimine yeni bir program oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.TrainingCover olmalıdır. PersonalTrainer\'ın varlığı PersonalTrainerMetadata tablosundan kontrol edilmelidir.
         * @param {CreateBroadcastProgramCommand} [createBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBroadcastProgram(createBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBroadcastProgram(createBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Yayın programını siler
         * @param {DeleteBroadcastProgramCommand} [deleteBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBroadcastProgram(deleteBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBroadcastProgram(deleteBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListBroadcastProgramsForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Yayın takvimini yönetim amacıyla listeler.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBroadcastProgramsForAdministration(page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBroadcastProgramsForAdministration(page, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateCoverPhotoOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının kapak fotoğrafını değiştirmeye yarar.
         * @param {UpdateCoverPhotoOfBroadcastProgramCommand} [updateCoverPhotoOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfBroadcastProgram(updateCoverPhotoOfBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCoverPhotoOfBroadcastProgram(updateCoverPhotoOfBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateEndMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının sonlanma anını değiştirmeye yarar. Dikkat: Yayının başlama anından sonra olmalıdır.
         * @param {UpdateEndMomentOfBroadcastProgramCommand} [updateEndMomentOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEndMomentOfBroadcastProgram(updateEndMomentOfBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEndMomentOfBroadcastProgram(updateEndMomentOfBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePersonalTrainerOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programını sunacak kişisel antrenörü değiştirmeye yarar.
         * @param {UpdatePersonalTrainerOfBroadcastProgramCommand} [updatePersonalTrainerOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalTrainerOfBroadcastProgram(updatePersonalTrainerOfBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePersonalTrainerOfBroadcastProgram(updatePersonalTrainerOfBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateStartMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının başlangıç anını değiştirmeye yarar. Dikkat: Yayının sonlanma tarihinden önce olmalıdır.
         * @param {UpdateStartMomentOfBroadcastProgramCommand} [updateStartMomentOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStartMomentOfBroadcastProgram(updateStartMomentOfBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStartMomentOfBroadcastProgram(updateStartMomentOfBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateTitleOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının başlığını değiştirmeye yarar.
         * @param {UpdateTitleOfBroadcastProgramCommand} [updateTitleOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfBroadcastProgram(updateTitleOfBroadcastProgramCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTitleOfBroadcastProgram(updateTitleOfBroadcastProgramCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.BroadcastProgramAdministrationApiFp = BroadcastProgramAdministrationApiFp;
/**
 * BroadcastProgramAdministrationApi - factory interface
 * @export
 */
const BroadcastProgramAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BroadcastProgramAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: CreateBroadcastProgram - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayın takvimine yeni bir program oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.TrainingCover olmalıdır. PersonalTrainer\'ın varlığı PersonalTrainerMetadata tablosundan kontrol edilmelidir.
         * @param {CreateBroadcastProgramCommand} [createBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBroadcastProgram(createBroadcastProgramCommand, options) {
            return localVarFp.createBroadcastProgram(createBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Yayın programını siler
         * @param {DeleteBroadcastProgramCommand} [deleteBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBroadcastProgram(deleteBroadcastProgramCommand, options) {
            return localVarFp.deleteBroadcastProgram(deleteBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListBroadcastProgramsForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Yayın takvimini yönetim amacıyla listeler.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBroadcastProgramsForAdministration(page, options) {
            return localVarFp.listBroadcastProgramsForAdministration(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateCoverPhotoOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının kapak fotoğrafını değiştirmeye yarar.
         * @param {UpdateCoverPhotoOfBroadcastProgramCommand} [updateCoverPhotoOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfBroadcastProgram(updateCoverPhotoOfBroadcastProgramCommand, options) {
            return localVarFp.updateCoverPhotoOfBroadcastProgram(updateCoverPhotoOfBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateEndMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının sonlanma anını değiştirmeye yarar. Dikkat: Yayının başlama anından sonra olmalıdır.
         * @param {UpdateEndMomentOfBroadcastProgramCommand} [updateEndMomentOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEndMomentOfBroadcastProgram(updateEndMomentOfBroadcastProgramCommand, options) {
            return localVarFp.updateEndMomentOfBroadcastProgram(updateEndMomentOfBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePersonalTrainerOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programını sunacak kişisel antrenörü değiştirmeye yarar.
         * @param {UpdatePersonalTrainerOfBroadcastProgramCommand} [updatePersonalTrainerOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalTrainerOfBroadcastProgram(updatePersonalTrainerOfBroadcastProgramCommand, options) {
            return localVarFp.updatePersonalTrainerOfBroadcastProgram(updatePersonalTrainerOfBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateStartMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının başlangıç anını değiştirmeye yarar. Dikkat: Yayının sonlanma tarihinden önce olmalıdır.
         * @param {UpdateStartMomentOfBroadcastProgramCommand} [updateStartMomentOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStartMomentOfBroadcastProgram(updateStartMomentOfBroadcastProgramCommand, options) {
            return localVarFp.updateStartMomentOfBroadcastProgram(updateStartMomentOfBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateTitleOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Halihazırda varolan bir yayın programının başlığını değiştirmeye yarar.
         * @param {UpdateTitleOfBroadcastProgramCommand} [updateTitleOfBroadcastProgramCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfBroadcastProgram(updateTitleOfBroadcastProgramCommand, options) {
            return localVarFp.updateTitleOfBroadcastProgram(updateTitleOfBroadcastProgramCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BroadcastProgramAdministrationApiFactory = BroadcastProgramAdministrationApiFactory;
/**
 * BroadcastProgramAdministrationApi - object-oriented interface
 * @export
 * @class BroadcastProgramAdministrationApi
 * @extends {BaseAPI}
 */
class BroadcastProgramAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: CreateBroadcastProgram - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Canlı yayın takvimine yeni bir program oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. SaveUploadedPhoto metodunun ikinci parametresi PhotoType.TrainingCover olmalıdır. PersonalTrainer\'ın varlığı PersonalTrainerMetadata tablosundan kontrol edilmelidir.
     * @param {CreateBroadcastProgramCommand} [createBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    createBroadcastProgram(createBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).createBroadcastProgram(createBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Yayın programını siler
     * @param {DeleteBroadcastProgramCommand} [deleteBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    deleteBroadcastProgram(deleteBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).deleteBroadcastProgram(deleteBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListBroadcastProgramsForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Yayın takvimini yönetim amacıyla listeler.
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    listBroadcastProgramsForAdministration(page, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).listBroadcastProgramsForAdministration(page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateCoverPhotoOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Halihazırda varolan bir yayın programının kapak fotoğrafını değiştirmeye yarar.
     * @param {UpdateCoverPhotoOfBroadcastProgramCommand} [updateCoverPhotoOfBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    updateCoverPhotoOfBroadcastProgram(updateCoverPhotoOfBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).updateCoverPhotoOfBroadcastProgram(updateCoverPhotoOfBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateEndMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Halihazırda varolan bir yayın programının sonlanma anını değiştirmeye yarar. Dikkat: Yayının başlama anından sonra olmalıdır.
     * @param {UpdateEndMomentOfBroadcastProgramCommand} [updateEndMomentOfBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    updateEndMomentOfBroadcastProgram(updateEndMomentOfBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).updateEndMomentOfBroadcastProgram(updateEndMomentOfBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePersonalTrainerOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Halihazırda varolan bir yayın programını sunacak kişisel antrenörü değiştirmeye yarar.
     * @param {UpdatePersonalTrainerOfBroadcastProgramCommand} [updatePersonalTrainerOfBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    updatePersonalTrainerOfBroadcastProgram(updatePersonalTrainerOfBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).updatePersonalTrainerOfBroadcastProgram(updatePersonalTrainerOfBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateStartMomentOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Halihazırda varolan bir yayın programının başlangıç anını değiştirmeye yarar. Dikkat: Yayının sonlanma tarihinden önce olmalıdır.
     * @param {UpdateStartMomentOfBroadcastProgramCommand} [updateStartMomentOfBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    updateStartMomentOfBroadcastProgram(updateStartMomentOfBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).updateStartMomentOfBroadcastProgram(updateStartMomentOfBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateTitleOfBroadcastProgram - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Halihazırda varolan bir yayın programının başlığını değiştirmeye yarar.
     * @param {UpdateTitleOfBroadcastProgramCommand} [updateTitleOfBroadcastProgramCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramAdministrationApi
     */
    updateTitleOfBroadcastProgram(updateTitleOfBroadcastProgramCommand, options) {
        return (0, exports.BroadcastProgramAdministrationApiFp)(this.configuration).updateTitleOfBroadcastProgram(updateTitleOfBroadcastProgramCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BroadcastProgramAdministrationApi = BroadcastProgramAdministrationApi;
